import InfiniteScroll from "react-infinite-scroll-component";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import moment from "moment";
import { Paragraph } from "theme-ui";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSowChecklist } from "../../../store/actions/project.action";
import { AllActivities, getUserName } from "../../../utils/activityHistoryHelper";
import { ActivityModalProps } from "../../../../@types";


const ActivityHistoryModal: React.FC<ActivityModalProps> = ({ isOpen, toggle, items, hasMore, colorMode, fetchMoreData, dataForTable, title = "All Activities" }) => {
    const dispatch = useDispatch();
    const { getproject, createprojectMasterData, SowChecklist } = useSelector((state: any) => state.project);
    useEffect(() => {
        if (!SowChecklist || !SowChecklist.length) {
            dispatch(getSowChecklist());
        }
    }, [dispatch, SowChecklist]);
    const titleHeader = colorMode === 'light' ? "secondary" : "#dadada";
    const modalHeader = colorMode === 'light' ? "#f6f6f6" : "#20283c";
    const [totalItems, setTotalItems] = useState(0);
    // const [hasMore, setHasMore] = useState(true);
    const uniqueItems = useMemo(() => {
        const seen = new Set();
        return items?.filter((history: any) => {
            const identifier = history?._id || history?.id || history?.changes?.updatedAt || history?.changes?.updateObject?.updatedAt || history?.updatedAt || history?.createdAt;
            if (seen.has(identifier)) {
                return false;
            } else {
                seen.add(identifier);
                return true;
            }
        });
    }, [items]);
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={toggle}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
            <ModalHeader toggle={toggle} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }}>{title}</ModalHeader>
            <ModalBody style={{ backgroundColor: modalHeader, color: titleHeader }}>
                <InfiniteScroll
                    dataLength={uniqueItems?.length || 0}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={<p></p>}
                    height={600}
                    endMessage={<p></p>}
                >
                    {(() => {
                        const seenTexts = new Set<string>();
                        return uniqueItems?.map((history: any, index: number) => {
                            const activityText = AllActivities(
                                history?.action,
                                history?.changes ? { ...history?.changes, stageId: history?.stageId || history?.changes?.stageId, taskId: history?.taskId || history?.changes?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.changes),
                                history?.oldData ? { ...history?.oldData, stageId: history?.stageId || history?.oldData?.stageId, taskId: history?.taskId || history?.oldData?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.oldData),
                                dataForTable?.data?.allProjectManagers,
                                dataForTable?.data?.allTaskManagers,
                                dataForTable?.data?.allProjectWorkers,
                                dataForTable?.data?.allTaskWorkers,
                                dataForTable?.data?.allHighlighters,
                                dataForTable?.data?.allArchitects,
                                true,
                                dataForTable?.data?.allStages,
                                dataForTable?.data?.allTask?.data || dataForTable?.data?.allTask || dataForTable?.data?.allTasks || createprojectMasterData?.allTask?.data,
                                createprojectMasterData?.allTaskSow?.data || createprojectMasterData?.allTaskSow || [createprojectMasterData, SowChecklist, dataForTable?.data]
                            );
                            if (!activityText) return null;
                            const timeKey = history?.createdAt ? moment(history.createdAt).format('YYYY-MM-DD-HH:mm') : index;
                            const normalized = `${timeKey}_${activityText.toLowerCase().replace(/['"\s_-]/g, '')}`;
                            if (seenTexts.has(normalized)) return null;
                            seenTexts.add(normalized);
                            return (
                                <div key={index} style={{ flexWrap: 'wrap' }}>
                                    <Paragraph style={{ gap: 2 }} variant="activityText">
                                        <strong style={{ marginRight: '6px' }}>{getUserName(history?.changes?.updatedBy || history?.changes?.updateObject?.updatedBy || history?.changes?.createdBy || history?.updatedBy || history?.createdBy, dataForTable?.data)}</strong>
                                        {' '}{activityText}
                                    </Paragraph>
                                    <Paragraph sx={{ textAlign: "end", fontSize: "10px", color: "#D3D5D9", marginBottom: "0px" }}>{moment(history?.createdAt).format('MMM DD, LT')}</Paragraph >
                                </div>
                            );
                        });
                    })()}
                </InfiniteScroll>
            </ModalBody>
            {/* <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
            </ModalFooter> */}
        </Modal>)
}

export default ActivityHistoryModal